
export default [ 
    {text: 'Main Projects Page', to: '/my-projects' },
    {text: 'Home Page', to: '/' },
    {text: 'Sign In / Sign Up', to: '/UserSignIn' },
];